var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Goto } from './base';
import { bridge } from '@funny/bridge';
var MarsGoto = /** @class */ (function (_super) {
    __extends(MarsGoto, _super);
    function MarsGoto() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarsGoto.prototype.soloRecordCover = function (songId) {
        throw new Error('Method not implemented.');
    };
    MarsGoto.prototype.memberCenter = function () {
        throw new Error('Method not implemented.');
    };
    MarsGoto.prototype.trendDetailPage = function (trendid) {
        throw new Error('Method not implemented.');
    };
    MarsGoto.prototype.giftHandbook = function () {
        throw new Error('Method not implemented.');
    };
    MarsGoto.prototype.activityCenter = function () {
        throw new Error('Method not implemented.');
    };
    MarsGoto.prototype.topUp = function (isHalf, closeBeforePage) {
        if (isHalf === void 0) { isHalf = true; }
        if (closeBeforePage === void 0) { closeBeforePage = true; }
        bridge.openPage('xiaochangmars://?ac=payment&is_show_half=' + isHalf ? '1' : '0', closeBeforePage);
    };
    MarsGoto.prototype.luboMall = function () {
        throw new Error('this method not be implemented into mars app');
    };
    MarsGoto.prototype.profile = function (userId, subTab, closeBeforePage) {
        if (closeBeforePage === void 0) { closeBeforePage = true; }
        var url = 'xiaochangmars://?ac=userinfo&uid=' + userId;
        bridge.openPage(url, closeBeforePage);
    };
    MarsGoto.prototype.baofangMall = function () {
        throw new Error('this method not be implemented into mars app');
    };
    return MarsGoto;
}(Goto));
export { MarsGoto };
